import BaseViewController from "./base-view-controller";
import { downloadPDF } from "../utils/download-pdf";
import { buildFilesList } from "../utils/files-list-builder";

class FilesListViewController extends BaseViewController {
  formState = {};

  prepareSubmit(values) {
    return { ...values, ...this.formState };
  }

  handleButtonClick(name, text, buttonAction) {
    switch (name) {
      case "downloadPDF":
        downloadPDF(buttonAction.value, buttonAction.name);
        break;
      default:
        super.handleButtonClick(name, text, buttonAction);
    }
  }

  preprocessScreenData() {
    this.screen = {
      ...this.screen,
      fields: [...this.screen.fields, ...buildFilesList(this.screen.data.files)]
    };
  }
}

export default FilesListViewController;
